import axios from 'axios';
import config from '../config';
// import jwtDecode from 'jwt-decode';

const APIClient = axios.create({
  baseURL: config.baseURL,
  withCredentials: true, // send cookies (e.g. session sid) for guest checkout
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// Add request interceptor: tag every request with the current UI language so
// the backend can localize language-aware responses (e.g. the symptom-search
// `matchedSymptom.label`). Falls back to German, the storefront default.
APIClient.interceptors.request.use(
  (config) => {
    try {
      const lang = localStorage.getItem('language') || 'de';
      config.headers = config.headers || {};
      config.headers['Accept-Language'] = lang;
    } catch (e) {
      // localStorage unavailable (SSR/private mode) — backend defaults to 'de'.
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle session expiration
APIClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Centralized session-expiry handling. Auth is carried by an httpOnly
    // cookie now, so there is no client-side token to check for — a 401 on a
    // non-auth call means the cookie is missing/invalid/expired, and we send
    // the user to login. We skip this for the login/signup/me/logout calls
    // themselves (a failed login is a 401 but must not trigger a redirect,
    // and a logged-out /me probe on load must not force a redirect loop).
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      const isAuthCall = /\/authentication\/(login|user\/login|client\/login|signup|me|logout)/.test(url);
      if (!isAuthCall) {
        if (window.location.pathname !== '/loginpage') {
          window.location.assign('/loginpage');
        }
      }
    }

    return Promise.reject(error);
  }
);

export default APIClient;